import React from 'react';
import { withRouter } from 'react-router-dom';
import PharmaCrowdWalletHeader from './CustodiyWalletHeader';

const Layout = () => (
  <PharmaCrowdWalletHeader />
);

export default withRouter(Layout);
